export default ({ newsletter }, _, { t }) => {
  if (newsletter) {
    return t('newsletter_page_meta_description');
  }
};
